<template>
    <div class="d-flex flex-wrap">
        <form-field :label="getFieldLabel('dbName')"
                    class="col-xs-12 col-sm-8 col-md-4 col-lg-3 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.dbName"
                    :editable="isEditable('dbName')"
                    :feedback="liveFeedback('dbName')">
            <template #field>
                    <b-input
                        id="dbName"
                        class="w-100"
                        v-model="$v.form.dbName.$model"
                        :state="validateState('dbName')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('chipId')"
                    class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.chipId"
                    :editable="isEditable('chipId')"
                    :feedback="liveFeedback('chipId')">
            <template #field>
                    <b-input
                        id="chipId"
                        class="w-100"
                         v-model="$v.form.chipId.$model"
                        :state="validateState('chipId')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('labelId')"
                    class="col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0 mr-0 mr-sm-3 mt-3"
                    :value="object.labelId"
                    :editable="isEditable('labelId')"
                    :feedback="liveFeedback('labelId')">
            <template #field>
                    <b-input
                        id="labelId"
                        class="w-100"
                         v-model="$v.form.labelId.$model"
                        :state="validateState('labelId')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('markingSpecialist')"
            class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0 mr-0 mr-sm-3 mt-3"
            :value="object.markingSpecialist"
            :editable="isEditable('markingSpecialist')"
            :feedback="liveFeedback('markingSpecialist')">
            <template #field>
                    <b-input
                        id="markingSpecialist"
                        class="w-100"
                         v-model="$v.form.markingSpecialist.$model"
                        :state="validateState('markingSpecialist')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('markingSpecialistPosition')"
            class="col-xs-12 col-sm-8 col-md-6 col-lg-5 p-0 mr-0 mr-sm-3 mt-3"
            :value="object.markingSpecialistPosition"
            :editable="isEditable('markingSpecialistPosition')"
            :feedback="liveFeedback('markingSpecialistPosition')">
            <template #field>
                    <b-input
                        id="markingSpecialistPosition"
                        class="w-100"
                         v-model="$v.form.markingSpecialistPosition.$model"
                        :state="validateState('markingSpecialistPosition')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('conclusion')"
                    class="col-xs-12 col-sm-12 col-md-6 p-0 mr-3 mt-3"
                    :value="object.conclusion"
                    :editable="isEditable('conclusion')"
                    :feedback="liveFeedback('conclusion')">
            <template #field>
                    <b-form-textarea
                        id="conclusion"
                        class="w-100"
                        v-model="$v.form.conclusion.$model"
                        :state="validateState('conclusion')">
                    </b-form-textarea>
            </template>
        </form-field>


    </div>

</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import {MarkingEventAttributes} from "./marking";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";

    export default {
        name: "MarkingAttributes",
        components: { FormField },
        mixins: [ObjectComponentMixin, AttributeMixin],
        beforeMount() {
            this.objectClass = MarkingEventAttributes;
            this.initialize();
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },

    }
</script>

<style scoped>

</style>